import {
  Button,
  Divider,
  Grid,
  TablePagination,
  Typography,
} from "@mui/material";
import React from "react";
import TablePaginationActions from "../../shared/components/Table/Actions";

const LocalList = ({ locais, setLocal, handleChangePage }) => {
  return (
    <Grid container direction="column" spacing={3}>
      <Grid>
        <Button variant="outlined" onClick={() => setLocal({ eNovo: true })}>
          Novo Local
        </Button>
      </Grid>
      <Grid>
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={locais.size ? locais.size : 0}
          component="div"
          count={locais.totalElements}
          page={locais.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            from +
            "-" +
            to +
            " de " +
            (count !== -1 ? count + " registros" : +" mais de " + to)
          }
          ActionsComponent={TablePaginationActions}
        />
      </Grid>
      {locais.content.map((local) => (
        <>
          <Grid>
            <Grid
              container
              direction="row"
              spacing={2}
              justifyContent="space-evenly"
            >
              <Grid>
                <Typography variant="body1">{local.descricao}</Typography>
              </Grid>
              <Grid>
                <Button variant="outlined" onClick={() => setLocal(local)}>
                  Selecionar
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <Divider />
          </Grid>
        </>
      ))}
      <Grid>
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={locais.size ? locais.size : 0}
          component="div"
          count={locais.totalElements}
          page={locais.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            from +
            "-" +
            to +
            " de " +
            (count !== -1 ? count + " registros" : +" mais de " + to)
          }
          ActionsComponent={TablePaginationActions}
        />
      </Grid>
    </Grid>
  );
};

export default LocalList;
